const routes = [
    {
        path: "/coop/companies",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true
        }
    }
];

export default routes;
